<div class="m-button-group-wrapper">
  @if (options.length) {
    @for (option of options; track option; let i = $index) {
      @if (option.tooltip) {
        <m-tooltip
          [content]="option.tooltip"
          [tooltipOptions]="option.tooltipOptions || {}">
          <div
            class="m-button-group-btn"
            [class.disabled]="disabled || option.disabled"
            [ngClass]="[option.value === selectedOption ? 'selected' : '']"
            (click)="$event.preventDefault(); onButtonClickHandler(i)">
            <div class="m-button-group-lbl">{{ option.label }}</div>
            @if (option.perOptionCount) {
              <span
                class="c3 text-gray-000 rounded-full ms-2 px-1"
                [ngClass]="[
                  option.value === selectedOption
                    ? 'bg-blue-600'
                    : 'bg-gray-800',
                ]"
                >{{ option.perOptionCount }}
              </span>
            }
          </div>
        </m-tooltip>
      } @else {
        <div
          class="m-button-group-btn"
          [class.disabled]="disabled || option.disabled"
          [ngClass]="[option.value === selectedOption ? 'selected' : '']"
          (click)="$event.preventDefault(); onButtonClickHandler(i)">
          <div class="m-button-group-lbl">{{ option.label }}</div>
          @if (option.perOptionCount) {
            <span
              class="c3 text-gray-000 rounded-full ms-2 px-1"
              [ngClass]="[
                option.value === selectedOption ? 'bg-blue-600' : 'bg-gray-800',
              ]"
              >{{ option.perOptionCount }}
            </span>
          }
        </div>
      }
    }
  } @else {
    <button type="button" class="button border-0 m-0 b2" [disabled]="true">
      No Data
    </button>
  }
</div>
